module.exports = __webpack_public_path__ + "static/media/CKN Digital Ad Outline & Script_1601635448474.6dc2d80d.docx";